@if (isAiAssistantEnabled$ | async) {
  <div class="ai-icon-container">
    <button
      matSuffix
      mat-icon-button
      color="primary"
      class="icon button"
      (click)="onAiAssistantClicked()"
    >
      <span class="material-symbols-outlined">auto_awesome</span>
    </button>
  </div>
}

<div class="zoom-container">
  <button (click)="onZoomOutClicked()" class="zoom-buttons zoom-out">
    <mat-icon>remove</mat-icon>
  </button>
  <button class="zoom-buttons zoom-indicator">
    {{ mapService.zoom | number: '.0-0' }}
  </button>
  <button (click)="onZoomInClicked()" class="zoom-buttons zoom-in">
    <mat-icon>add</mat-icon>
  </button>
</div>

@if (layoutService.isDesktopView$ | async) {
  <div>
    <div class="map-icons-container">
      @if (showButtons) {
        <atlas-map-measure-control
          [measurement]="measurement"
          [measureMode]="mapService.measureMode$ | async"
          (measureOptionClicked)="onMeasuredMapClicked($event)"
          (close)="onMeasuredMapCloseClicked()"
        ></atlas-map-measure-control>

        <button
          matSuffix
          mat-icon-button
          color="primary"
          class="icon button"
          (click)="onToggleMap3d()"
        >
          <span class="material-symbols-outlined">3d_rotation </span>
        </button>

        <button
          matSuffix
          mat-icon-button
          color="primary"
          class="icon button"
          (click)="onCopydMapClicked()"
        >
          <span class="material-symbols-outlined">content_copy</span>
        </button>

        @if (isShareMapEnabled && showShareMap) {
          <button
            matSuffix
            mat-icon-button
            color="primary"
            class="icon button"
            aria-label="Share map"
            (click)="onShareMapClicked()"
          >
            <span class="material-symbols-outlined">share</span>
          </button>
        }

        <button
          matSuffix
          mat-icon-button
          color="primary"
          class="icon button"
          (click)="onDownloadMapClicked()"
        >
          <span class="material-symbols-outlined">download_2</span>
        </button>
      }
    </div>

    @if (showButtons) {
      <button
        matSuffix
        mat-icon-button
        color="primary"
        class="close-icon main-icon button"
        (click)="onCloseClicked()"
      >
        <span class="material-symbols-outlined">Close</span>
      </button>
    } @else {
      <button
        matSuffix
        mat-icon-button
        color="primary"
        class="icon main-icon button"
        (click)="onScreenshotClicked()"
      >
        <span class="material-symbols-outlined">map</span>
      </button>
    }
  </div>
}
